
export const sidebarItemClassName =
  'hover:bg-primary-50 flex group items-center justify-between gap-2 rounded-md px-3 py-1.5 text-sm';
